<script lang="ts">
    import MedialibFile from "./MedialibFile.svelte"

    export let id: string
    export let filter: null | "xs" | "s" | "m" | "l" | "xl" | "xxl" = null
    export let minWidth: number = null
    export let noPlaceholder: boolean = false

    let imgElement: HTMLImageElement

    function getSrcWithFilter(_imgElement: HTMLImageElement, entry: MedialibEntry, src: string) {
        if (!entry.file?.type?.match(/^image\/(png|jpe?g)/)) {
            return src // no filter for svg
        }
        if (typeof window === "undefined") {
            return src
        }
        if (imgElement) {
            let _filter = filter
            if (!_filter) {
                // get the width of the image element
                const width = minWidth
                    ? _imgElement.width < minWidth
                        ? minWidth
                        : _imgElement.width
                    : _imgElement.width
                switch (true) {
                    case width <= 90:
                        _filter = "xs"
                        break
                    case width <= 300:
                        _filter = "s"
                        break
                    case width <= 600:
                        _filter = "m"
                        break
                    case width <= 1200:
                        _filter = "l"
                        break
                    case width <= 2000:
                        _filter = "xl"
                        break
                    case width <= 4000:
                        _filter = "xxl"
                        break
                }
            }
            return src + (_filter ? `?filter=${_filter}` : "")
        } else {
            // placeholder
            return "/assets/img/placeholder-image.png"
        }
    }
</script>

{#if id}
    <MedialibFile {id} let:entry let:src {noPlaceholder}>
        <picture>
            {#if !filter && entry.file?.type?.match(/^image\/(png|jpe?g)/)}
                <source media="(max-width: 89px)" srcset="{src}?filter=xs" />
                <source media="(max-width: 299px)" srcset="{src}?filter=s" />
                <source media="(max-width: 599px)" srcset="{src}?filter=m" />
                <source media="(max-width: 1199px)" srcset="{src}?filter=l" />
                <source media="(max-width: 1999px)" srcset="{src}?filter=xl" />
                <source media="(max-width: 3999px)" srcset="{src}?filter=xxl" />
                <img bind:this="{imgElement}" src="{src}?filter=m" alt="{entry.alt || 'image'}" data-entry-id="{id}" />
            {:else}
                <img
                    bind:this="{imgElement}"
                    src="{getSrcWithFilter(imgElement, entry, src)}"
                    alt="{entry.alt || 'image'}"
                    data-entry-id="{id}"
                />
            {/if}
        </picture>
        <picture slot="loading" let:entry let:src>
            <img
                src="/assets/img/placeholder-image.png"
                alt="placeholder"
                data-entry-id="{id}"
                data-entry="{JSON.stringify(entry)}"
                data-entry-src="{src}"
            />
        </picture>
        <picture slot="not-found">
            <img src="/assets/img/placeholder-image.png" alt="not found" data-entry-id="{id}" />
        </picture>
    </MedialibFile>
{/if}
